import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: process.env.REACT_APP_THEME_PRIMARY_COLOR,
        },
        secondary: {
            main: process.env.REACT_APP_THEME_SECONDARY_COLOR,
        },
    },
    typography: {
        fontFamily: [
            'Proxima Nova Soft',
            'Arial',
            'Helvetica',
            'sans-serif',
        ].join(','),
    },
    overrides: {
        MuiButton: {
            root: {
                height: 44,
                borderRadius: 5,
                textTransform: 'uppercase',
                boxShadow: 'none',
                fontWeight: 600,
                fontSize: 11,
                padding: '8px 20px',
            },
            sizeSmall: {
                height: 24,
                minHeight: 24,
                fontSize: 11,
                padding: '5px 10px',
            },
            sizeLarge: {
                height: 60,
                fontSize: 14,
                minWidth: 170,
            },
            contained: {
                boxShadow: 'none',
            }
        },
        MuiBackdrop: {
            root: {
                backgroundColor: 'rgba(50,50,50,0.8)',
            }
        },
    },
});

export default theme;


// WEBPACK FOOTER //
// ./src/features/Layout/theme.js